module.exports = __webpack_public_path__ + "static/media/add exam.288fad33.svg";